import { BackendApi } from "./backend";

export class PuceApp {
  backend = new BackendApi();
}
